import api from 'api'
import { validateSession } from 'utils/session'

export const get = async (domain, id) => {
	const { data } = await api.dueDiligence[domain]?.get(id)
	return data
}

export const getAll = async (domain) => {
	const { data } = await api.dueDiligence[domain]?.getAll()
	const { pageData } = data
	return pageData
}

/**
 * Validates the current session before firing async calls
 * @param {Array} promises Promises to be fired after the session is validated
 */
export const promiseAll = async (promises = []) => {
	try {
		await validateSession()
		return await Promise.all(promises.map((promise) => promise()))
	} catch (err) {
		console.error(err)
		return Promise.reject(err)
	}
}
